export default __webpack_public_path__ + "static/media/tool-icon-cone-low-blue.1b2674d9.svg";